import React from 'react';
import PropTypes from 'prop-types';

import suitcss from '../../../helpers/suitcss';
import FormSection from '../form/FormSection';
import FormHeader from '../form/FormHeader';
import PaymentModule from '../../../containers/form/PaymentModule';

const componentName = 'ActivationFormPayment';
const ActivationFormPayment = props => {
  const { params, onError, form, fieldMap, ui, formValues } = props;
  return (
    <FormSection className={suitcss({ componentName })} asRow>
      <FormHeader headline={params.paymentHeadline} copy={params.paymentCopy} ui={ui} />
      <PaymentModule
        className={suitcss({ utilities: ['lCol10', 'grid'] })}
        paymentHeadline={params.paymentHeadline}
        paymentCopy={params.paymentCopy}
        onError={onError}
        form={form}
        fieldMap={fieldMap}
        formValues={formValues}
      />
    </FormSection>
  );
};

ActivationFormPayment.propTypes = {
  // form logic
  onError: PropTypes.func.isRequired,
  fieldMap: PropTypes.object.isRequired,
  form: PropTypes.string.isRequired,
  ui: PropTypes.object.isRequired,
  params: PropTypes.shape({
    paymentHeadline: PropTypes.string.isRequired,
  }),
  formValues: PropTypes.object.isRequired,
};

export default ActivationFormPayment;
